export const AFTER_NEXT_QUESTION = 'AFTER_NEXT_QUESTION';
export const NEXT_QUESTION = 'NEXT_QUESTION';
export const EDIT_QUESTION = 'EDIT_QUESTION';
export const PRE_EDIT_QUESTION = 'PRE_EDIT_QUESTION';
export const UPDATE_FIELD_VALUE = 'UPDATE_FIELD_VALUE';
